import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";

export function exportToPDF(config) {
	const doc = new jsPDF({ orientation: "landscape" });

	// Header bar
	doc.setFillColor(17, 138, 128);
	doc.rect(0, 0, 297, 22, "F");
	doc.setTextColor(255, 255, 255);
	doc.setFontSize(14);
	doc.setFont("helvetica", "bold");
	doc.text("SISAGRI — " + config.title, 14, 10);
	doc.setFontSize(9);
	doc.setFont("helvetica", "normal");
	doc.text(config.subtitle || "Distribuição de Vegetais Frescos", 14, 17);

	const now = new Date();
	doc.setFontSize(8);
	doc.text(`Gerado em: ${now.toLocaleDateString("pt-BR")} ${now.toLocaleTimeString("pt-BR")}`, 250, 10);

	let startY = 28;

	// KPIs row
	if (config.kpis && config.kpis.length > 0) {
		const kpiWidth = 60;
		config.kpis.forEach((kpi, i) => {
			const x = 14 + i * kpiWidth;
			doc.setFillColor(245, 247, 245);
			doc.roundedRect(x, startY, kpiWidth - 4, 18, 2, 2, "F");
			doc.setTextColor(100, 100, 100);
			doc.setFontSize(7);
			doc.text(kpi.label, x + 3, startY + 6);
			doc.setTextColor(17, 138, 128);
			doc.setFontSize(11);
			doc.setFont("helvetica", "bold");
			doc.text(kpi.value, x + 3, startY + 14);
			doc.setFont("helvetica", "normal");
		});
		startY += 24;
	}

	// Table
	autoTable(doc, {
		startY,
		head: [config.headers],
		body: config.rows.map((row) => row.map(String)),
		styles: { fontSize: 8, cellPadding: 2 },
		headStyles: {
			fillColor: [17, 138, 128],
			textColor: [255, 255, 255],
			fontStyle: "bold",
			fontSize: 8,
		},
		alternateRowStyles: { fillColor: [245, 247, 245] },
		margin: { left: 14, right: 14 },
	});

	// Footer
	const pageCount = doc.getNumberOfPages();
	for (let i = 1; i <= pageCount; i++) {
		doc.setPage(i);
		doc.setFontSize(7);
		doc.setTextColor(150, 150, 150);
		doc.text(`Página ${i} de ${pageCount}`, 14, 200);
		doc.text("Sistema de Rastreabilidade — Distribuição de Vegetais Frescos", 297 / 2, 200, { align: "center" });
	}

	doc.save(`${config.filename}.pdf`);
}

export function exportToExcel(config) {
	const wsData = [];

	// Title rows
	wsData.push([config.title]);
	wsData.push([config.subtitle || "Distribuição de Vegetais Frescos"]);
	wsData.push([`Gerado em: ${new Date().toLocaleDateString("pt-BR")} ${new Date().toLocaleTimeString("pt-BR")}`]);
	wsData.push([]);

	// KPIs
	if (config.kpis && config.kpis.length > 0) {
		wsData.push(config.kpis.map((k) => k.label));
		wsData.push(config.kpis.map((k) => k.value));
		wsData.push([]);
	}

	// Headers + data
	wsData.push(config.headers);
	config.rows.forEach((row) => wsData.push(row));

	const ws = XLSX.utils.aoa_to_sheet(wsData);
	ws["!cols"] = config.headers.map((h) => ({ wch: Math.max(h.length + 4, 14) }));

	const wb = XLSX.utils.book_new();
	XLSX.utils.book_append_sheet(wb, ws, "Relatório");
	XLSX.writeFile(wb, `${config.filename}.xlsx`);
}
